import React from "react";
import Dropdown from "../dropdown/Dropdown";
import { withDefaults } from "../../utils/withDefaults";

/** Google font name to the generic family it falls back to. */
export const fonts: Record<string, string> = {
  "Amatic SC": "cursive",
  Anton: "sans-serif",
  "Carter One": "cursive",
  "Indie Flower": "cursive",
  "Josefin Slab": "serif",
  "Kaushan Script": "cursive",
  Lato: "sans-serif",
  Merienda: "cursive",
  Merriweather: "serif",
  Monoton: "cursive",
  Oswald: "sans-serif",
  "Permanent Marker": "cursive",
  "Press Start 2P": "cursive",
  Staatliches: "cursive",
  Tangerine: "cursive",
  Teko: "sans-serif",
  Ubuntu: "sans-serif",
  "Yanone Kaffeesatz": "sans-serif"
};

export interface FontPickerProps {
  label?: string;
  fontStyleClassName?: string;
  selectedFont?: string;
  onFontSelect?: (font: string) => void;
}

export default function FontPicker(incomingProps: FontPickerProps) {
  const props = withDefaults(incomingProps, fontPickerDefaultProps);

  return (
    <Dropdown
      choices={Object.keys(fonts)}
      choicesStyles={Object.entries(fonts).map(([font, fallback]) => ({
        fontFamily: `"${font}", ${fallback}`
      }))}
      dropdownValue={props.selectedFont}
      setDropdownValue={props.onFontSelect}
      selectedChoiceClassName={props.fontStyleClassName}
    />
  );
}

const fontPickerDefaultProps = {
  label: "Header Font",
  fontStyleClassName: "header-layout-font",
  selectedFont: "Lato",
  onFontSelect: () => {}
};
